import React from "react";
import styled from "styled-components";
import { MdMoreVert } from "react-icons/md";

import ReportDropDown from "./Components/ReportDropDown";
import { Tooltip } from "../../../../../../Components/Tooltip";
import { Button } from "../../../../../../Components/Button";

export default function ReportDropdown({
  size,
  children,
  classification = "secondary",
  optionsProps,
}) {
  return (
    <>
      <DropdownContainer
        type="click"
        position={{
          bottom: "10px",
          left: "15px",
        }}
        tooltipContent={<ReportDropDown optionsProps={optionsProps} />}
      >
        <Button
          size={size}
          classification={classification}
          flex={true}
          justifyContent="flex-start"
        >
          <StyledMore size={24}></StyledMore>
          {children}
        </Button>
      </DropdownContainer>
    </>
  );
}

const DropdownContainer = styled(Tooltip)`
  z-index: 10;
  &:hover {
    cursor: default;
  }
`;

const StyledMore = styled(MdMoreVert)`
  position: relative;
  top: 2px;

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    min-width: 20px;
    min-height: 20px;
  }
`;
